import React from "react";
import ReactTooltip from "react-tooltip";
import styled, { css } from "styled-components";

import { Icon } from "src/library/components/Icon";
import { Icons } from "src/library/components/Icon/types";

import {
  DashboardMode,
  useDashboardContext
} from "../../contexts/DashboardContext";

const DashboardModeSwitcher: React.FC = () => {
  const { updateMode, fullScreenState } = useDashboardContext();

  return (
    <StyledIconWrapper>
      <Icon
        icon={Icons.DASHBOARDEDIT}
        $fillColor={fullScreenState.active ? "white" : "primaryLight"}
        onClick={() => updateMode(DashboardMode.Edit)}
        data-tip
        data-for="dashboard-edit-tooltip"
        cursor="pointer"
      />

      <ReactTooltip
        id="dashboard-edit-tooltip"
        place="left"
      >
        Edit Dashboard
      </ReactTooltip>

      <Icon
        icon={fullScreenState.active ? Icons.CLOSE : Icons.FULLSCREEN}
        $fillColor={fullScreenState.active ? "white" : "primaryLight"}
        onClick={() => {
          if (fullScreenState.active) {
            fullScreenState.exit();
          } else {
            fullScreenState.enter();
          }
        }}
        data-tip
        data-for="fullscreen-tooltip"
        cursor="pointer"
      />

      <ReactTooltip
        id="fullscreen-tooltip"
        place="left"
      >
        {fullScreenState.active ? "Exit Fullscreen" : "Fullscreen"}
      </ReactTooltip>
    </StyledIconWrapper>
  );
};

const StyledIconWrapper = styled.div`
  ${({ theme }) => css`
    padding: ${theme.spacing.padding.md} 0;
  `}
`;

export default DashboardModeSwitcher;
